const MAX_DESKTOP_SIZE = 1400;

function desktopWidthFor(imageIndex: number, chunkLength: number) {
  switch (chunkLength) {
    case 1: {
      return MAX_DESKTOP_SIZE;
    }
    case 2: {
      return MAX_DESKTOP_SIZE / 2;
    }
    case 3: {
      if (imageIndex === 0) {
        return (MAX_DESKTOP_SIZE * 2) / 3;
      }

      if (imageIndex === 1 || imageIndex === 2) {
        return MAX_DESKTOP_SIZE / 3;
      }

      return MAX_DESKTOP_SIZE / 3;
    }
    case 4: {
      return MAX_DESKTOP_SIZE / 2;
    }
    case 5: {
      if (imageIndex === 0) {
        return (MAX_DESKTOP_SIZE * 4) / 6;
      }

      if (imageIndex === 1 || imageIndex === 2) {
        return (MAX_DESKTOP_SIZE * 2) / 6;
      }

      if (imageIndex === 3 || imageIndex === 4) {
        return (MAX_DESKTOP_SIZE * 3) / 6;
      }

      return MAX_DESKTOP_SIZE / 3;
    }
    case 6: {
      if (imageIndex === 0) {
        return (MAX_DESKTOP_SIZE * 2) / 3;
      }

      return MAX_DESKTOP_SIZE / 3;
    }
    default: {
      return MAX_DESKTOP_SIZE / 2;
    }
  }
}

export function sizesFor(imageIndex: number, chunkLength: number) {
  const desktopPX = Math.round(desktopWidthFor(imageIndex, chunkLength));

  return `(max-width: 767px) 100vw, (max-width: 1279px) 50vw, ${desktopPX}px`;
}
